import { BuyGuideVendorRebateProgramList } from '../../../components/BuyGuide/BuyGuideVendorRebateProgramList';

export function BuyGuideVendorRebatePrograms() {
  return <BuyGuideVendorRebateProgramList />;
}
